const theme = {
    Root: {
        borderRadius: '8px',
        background: '#fff',
        color: '#000',
        padding: '5px',
        width: "360px",
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // paddingLeft:"11px",
    },
    Header: {
        height: '40px',
        padding: '0 10px 0 10px',
        width: "100%",
        '@media(max-width: 480px)': {
            height: '25px',
            padding: '5px 5px 0px 5px',
        }        
    },
    WeekHeader: {
        // paddingLeft: '5px',
        marginBottom: '5px',
        color: "#000",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        '@media(max-width: 480px)': {
            paddingLeft: '0px',
            marginBottom: '5px',
        }
    },
    MonthTitle: {
        fontSize: '20px',
        fontWeight: 'normal',
        textAlign: "center",
        width: "100%",
        paddingBottom: '20px',
        '@media(max-width: 480px)': {
            fontSize: '16px',
        }
    },
    YearTitle: {
        fontSize: '14px',
        fontWeight: 'bold',
        '@media(max-width: 480px)': {
            fontSize: '16px',
        }
    },
    PreviousButton: {
        width: '20px',
        height: '20px',
        background: 'none',
        border: 'solid black',
        borderWidth: '0 3px 3px 0',
        display: 'inline-block',
        padding: '3px',
        transform: 'rotate(135deg)',
        '-webkit-transform': 'rotate(135deg)',
        '::before': {
            content: "''"
        },
        '@media(max-width: 480px)': {
            width: '12px',
            height: '12px',
        }
    },
    NextButton: {
        width: '20px',
        height: '20px',
        background: 'none',
        border: 'solid black',
        borderWidth: '0 3px 3px 0',
        display: 'inline-block',
        padding: '3px',
        transform: 'rotate(-45deg)',
        '-webkit-transform': 'rotate(-45deg)',
        '::before': {
            content: "''"
        },
        '@media(max-width: 480px)': {
            width: '12px',
            height: '12px',
        }
    },
    Month: {
        minHeight: '0px',
        // paddingLeft:"10px"
    },
    MonthGroup: {
        // paddingLeft:"20px",
        '@media(max-width: 480px)': {
            padding: '0px 5px 0px 5px'
        }
    },
    Day: {
        color: '#000',
        width: '40px',
        height: '40px',
        margin: '15px',
        '@media(max-width: 480px)': {
            margin: '4px',
            padding: '3px',
            borderRadius: '30px',
            width: '30px',
            height: '30px',
        }
    },
    DayOfWeek: {
        width: '40px',
        margin: '0 5px',
        fontSize: '12px',
        color: '#cdcdcd',
        paddingLeft:"11px",
        '@media(max-width: 480px)': {
            margin: '4px',
            padding: '4px',
            borderRadius: '30px',
            width: '30px',
            height: '30px',
        }
    }
};

export default theme;